import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import circleAIBotAvatar from "../../assets/icons/CircleAIBot-avatar.png";

export const BotAvatar = () => {
  const { currentCommunitySettings, isLoading: isLoadingPunditUserContext } =
    usePunditUserContext();

  const isCopilotActionsEnabled =
    !isLoadingPunditUserContext && currentCommunitySettings?.copilot_v2_enabled;

  return (
    <div className="flex size-4 shrink-0 justify-center overflow-hidden rounded-full">
      <img
        src={circleAIBotAvatar}
        alt={
          isCopilotActionsEnabled
            ? t("help_widget.home_page.copilot_alt")
            : t("help_widget.home_page.circle_ai_bot_alt")
        }
        className="size-full object-contain"
        loading="eager"
      />
    </div>
  );
};
